import * as types from '../action/actionTypes';
import initialState from './initialState';

export default function ZonesReducer(state = initialState.Zones, action) {
    switch (action.type) {
        case types.GET_ZONES_LIST_SUCCESSFULL: return {
           ...state, ZonesList: action.getResponse,
        };
        case types.GET_ZONES_DETAILS_FOR_STATE_SUCCESSFULL: return {
            ...state, ClientSideZonesData: action.Data,
         };
        
        default : return state; 
    }   
}